<div class='devo-pipeline-tab1-part'>
	This is devo-pipeline tab 1
</div>